var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-profile-form',{staticClass:"current-user-profile-container",attrs:{"user":_vm.userForForm}})}
var staticRenderFns = []

export { render, staticRenderFns }